import Vue from 'vue'
import Mutations from '@/store/data/mutations'
export default {
  namespaced: true,
  state: {
    contractorId: null,
    filterBy: "",
    filterCol: "",
    siteId: null,
    notes: null,
    date: null,
    batches: [],
    selected: [],
    selectedAll: false,
    pagination: {},
    fetchBatches: false,
    fetchLines: false
  },
  mutations: Mutations,
  actions: {
  },
  getters: {
  }
}